import { translationsPromise } from '../constants/lib'
import { Form } from '@icure/form/components/model'
import { getAllFields } from './fields'

export const translate = async (language: string, section: string, text: string, ...argsPromises: Promise<string>[]) => {
  const t = await translationsPromise
  const args = await Promise.all(argsPromises)

  const translation = t?.[language]?.[section]?.[text]?.replace(/\$([1-9][0-9]*)|\$\{([1-9][0-9]*)(\|.+?)}/g, (_0, _1: string, _1b: string, _2: string) => {
    const idx = _1?.length ? parseInt(_1) - 1 : _1?.length ? parseInt(_1) - 1 : undefined
    return (idx !== undefined ? args[idx] : undefined) ?? (_2?.length ? _2.substring(1) : '')
  })
  if (translation) {
    return translation
  } else {
    return text
  }
}

export const translateSection = async (language: string, section: string) => {
  const t = await translationsPromise
  return t?.[language]?.[section]
}

export const populateFormTranslations = async (form: Form) => {
  const t = await translationsPromise
  for (const tt of form.translations ?? []) {
    const lang = t[tt.language] ?? (t[tt.language] = {})
    const section = lang['this'] ?? (lang['this'] = {})
    for (const [k, v] of Object.entries(tt.translations)) {
      section[k] = v
    }
    for (const field of getAllFields(form)) {
      if (field.options) {
        for (const [code, i18nKey] of Object.entries(field.options)) {
          const translated = tt.translations[i18nKey as string]
          if (translated) {
            section[code] = translated
          }
        }
      }
    }
  }
}
